var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConsultChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1707481657"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 525",
    cx: 30,
    cy: 30,
    r: 30,
    fill: "var(--fill-0, #EEE0AF)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "007.message"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M41.6667 28.8333C41.6667 22.39 36.4433 17.1667 30 17.1667C23.5567 17.1667 18.3333 22.39 18.3333 28.8333C18.3333 35.2767 23.5567 40.5 30 40.5C36.4433 40.5 41.6667 35.2767 41.6667 28.8333Z",
    fill: "var(--fill-0, #88BFFF)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.8333 37.1641L18.3333 40.5007H30V38.1674L21.8333 37.1641Z",
    fill: "var(--fill-0, #88BFFF)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M32.9167 30H24.75C24.4278 30 24.1667 30.2612 24.1667 30.5833V31.75C24.1667 32.0722 24.4278 32.3333 24.75 32.3333H32.9167C33.2388 32.3333 33.5 32.0722 33.5 31.75V30.5833C33.5 30.2612 33.2388 30 32.9167 30Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M35.25 25.3333H24.75C24.4278 25.3333 24.1667 25.5945 24.1667 25.9167V27.0833C24.1667 27.4055 24.4278 27.6667 24.75 27.6667H35.25C35.5722 27.6667 35.8333 27.4055 35.8333 27.0833V25.9167C35.8333 25.5945 35.5722 25.3333 35.25 25.3333Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultChat);
export default __webpack_public_path__ + "static/media/consult-chat.fb575fc0275099e3985dd24fd7d906d7.svg";
export { ForwardRef as ReactComponent };